<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <div class="loader" v-if="loadingOptimoRoute"></div>
        <form @submit.prevent="updateTrip">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-3">
                        <div class="h2">#{{ trip.optimoroute_id }} - {{ trip.type }}
                        </div>
                        #<a :href="`/bookings/${trip.booking.id}/edit`" title="Booking details">
                        B-{{ trip.booking.id }} </a>
                        -
                        <a :href="`/clients/${trip.client.id}/edit`" title="client details"> {{
                                trip.client.name
                            }}
                        </a>
                    </div>
                    <div class="col-md-9">
                        <div class="btn-group status-icons float-right shadow-sm" role="group" aria-label="">
                            <div
                                class="btn  d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===0 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="hourglass_empty">hourglass_empty
                                </div>
                                <span class="status-label">Awaiting goods</span>
                            </div>

                            <div
                                class="btn  d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===1 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="person_add">person_add
                                </div>
                                <span class="status-label">New</span>
                            </div>


                            <div
                                class="btn  d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===8 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="sms">sms
                                </div>
                                <span class="status-label"> Awaiting reply</span>
                            </div>


                            <div
                                class="btn  d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===5 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="event_busy">event_busy
                                </div>
                                <span class="status-label"> Failed</span>
                            </div>

                            <div
                                class="btn  d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===2 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="published_with_changes">published_with_changes
                                </div>
                                <span class="status-label"> Transferred</span>
                            </div>

                            <div
                                class="btn  d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===3 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="today">today
                                </div>
                                <span class="status-label"> Scheduled</span>
                            </div>

                            <div
                                class="btn  d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===4 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="local_shipping">local_shipping
                                </div>
                                <span class="status-label"> Servicing</span>
                            </div>

                            <div
                                class="btn  d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===6 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="close">close
                                </div>
                                <span class="status-label"> Rejected</span>
                            </div>

                            <div
                                class="btn d-flex align-items-center float-left status-block status-text"
                                :class="trip.status_id===7 ? 'status-block status-text border-bottom-status' : 'status-block-inactive status-text-inactive'"
                            >
                                <div
                                    class="material-icons-outlined cursor-pointer mr-1"
                                    title="verified">verified
                                </div>
                                <span class="status-label"> Delivered</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="trip-block-height p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Address</div>
                                        <a @click="isEditingAddress = !isEditingAddress; setHourRange(trip.time_day)" v-if="!isEditingAddress">
                                            <span
                                                class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                        </a>
                                        <a class="cursor-pointer" v-if="isEditingAddress"
                                           @click="isEditingAddress = false">
                                            <small>cancel editing</small>
                                        </a>
                                    </div>
                                    <div class="pt-3">
                                        <div v-if="isEditingAddress">
                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="name">Name</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddress, 'border-danger': trip.address.name==='' && isSubmit}">
                                                    <input type="text"
                                                           id="name"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="trip.address.name"
                                                           :disabled="!isEditingAddress"
                                                           :class="{view: !isEditingAddress}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="street">Street</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddress, 'border-danger': trip.address.street==='' && isSubmit}">
                                                    <input type="text"
                                                           id="street"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="trip.address.street"
                                                           :disabled="!isEditingAddress"
                                                           :class="{view: !isEditingAddress}">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="zip">Zip</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddress, 'border-danger': trip.address.zip==='' && isSubmit}">
                                                    <input type="text"
                                                           id="zip"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="trip.address.zip"
                                                           :disabled="!isEditingAddress"
                                                           :class="{view: !isEditingAddress}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="city">City</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddress, 'border-danger': trip.address.city==='' && isSubmit}">
                                                    <input type="text"
                                                           id="city"
                                                           autocomplete="off"
                                                           required
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="trip.address.city"
                                                           :disabled="!isEditingAddress"
                                                           :class="{view: !isEditingAddress}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="country">Country</label>
                                                <select class="form-control" id="country" v-model="trip.address.country_id">
                                                    <option v-for="item in countryList" :value="item.id">
                                                        {{ item.name }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="phone">Phone</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddress, 'border-danger': trip.address.phone==='' && isSubmit}">
                                                    <input type="text"
                                                           id="phone"
                                                           autocomplete="off"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="trip.address.phone"
                                                           placeholder="phone"
                                                           :disabled="!isEditingAddress"
                                                           :class="{view: !isEditingAddress}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="date">Date</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddress, 'border-danger': trip.time_day==='' && isSubmit}">
                                                    <date-picker
                                                        manual-input
                                                        v-model="trip.time_day"
                                                        valueType="format"
                                                        input-class="border-0 py-0 shadow-none form-input"
                                                        :lang="datePickerOptions.lang"
                                                        :disabled="!isEditingAddress"
                                                        placeholder="dd-mm-yyyy"
                                                        :clearable="false"
                                                        format="DD-MM-YYYY"
                                                        @input="handleDateChange"
                                                        :get-classes="getClassesDatepicker"
                                                    >
                                                    </date-picker>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="time-start">
                                                    Time start
                                                </label>
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="trip.time_start==='' && isSubmit? '':''"
                                                    ref="StartTime">
                                                    <vue-timepicker
                                                        hide-clear-button
                                                        manual-input
                                                        placeholder="Start"
                                                        v-model="trip.time_start"
                                                        input-class="border-0 py-0 shadow-none form-input short-input">
                                                    </vue-timepicker>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="time-end">
                                                    Time end
                                                </label>
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="trip.time_end==='' && isSubmit? '':''"
                                                    ref="EndTime">
                                                    <vue-timepicker
                                                        hide-clear-button
                                                        manual-input
                                                        placeholder="End"
                                                        v-model="trip.time_end"
                                                        input-class="border-0 py-0 shadow-none form-input short-input">
                                                    </vue-timepicker>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="delivered-start">
                                                    Delivered start
                                                </label>
                                                <div>
                                                    {{ trip.delivered_start }}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="delivered-end">
                                                    Delivered end
                                                </label>
                                                <div>
                                                    {{ trip.delivered_end }}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="d-block mb-0 font-weight-bold" for="note">Note</label>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddress}">
                                                    <input type="text"
                                                           id="note"
                                                           autocomplete="off"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="trip.note"
                                                           placeholder="note"
                                                           :disabled="!isEditingAddress"
                                                           :class="{view: !isEditingAddress}">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <span class="font-weight-semi-bold">Name: </span> {{ trip.address.name }}
                                            <br>
                                            <span class="font-weight-semi-bold">Address: </span> {{
                                                trip.address.street
                                            }},
                                            {{ trip.address.zip }}
                                            {{ trip.address.city }},
                                            {{ trip.address.country ? trip.address.country.name : 'Denmark' }},
                                            <br>
                                            <span class="font-weight-semi-bold">Phone: </span> {{ trip.address.phone }}
                                            <br>

                                            <div>
                                                <i class="oi oi-calendar"> </i>
                                                {{ trip.time_day }} <br>
                                                <i class="oi oi-clock"> </i>
                                                <span v-if="trip.time_start!=='00:00'">
                                                  {{ trip.time_start }}
                                                 </span>
                                                -
                                                <span v-if="trip.time_end!=='00:00'">
                                                   {{ trip.time_end }}
                                               </span><br>
                                                <div class="d-flex align-items-center">
                                                    <span class="material-symbols-outlined pr-1">local_shipping</span>
                                                    <span>
                                                        {{ trip.delivered_start }} -
                                                        {{ trip.delivered_end }}
                                                    </span>
                                                </div>
                                            </div>
                                            {{ trip.note }} <br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom ">
                                        <div class="h3 mb-0">Trip status</div>
                                        <a @click="isEditingStatus = !isEditingStatus" v-if="!isEditingStatus">
                                            <span
                                                class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                        </a>
                                        <a class="cursor-pointer" v-if="isEditingStatus"
                                           @click="isEditingStatus = false">
                                            <small>cancel editing</small>
                                        </a>
                                    </div>
                                    <div class="pt-3">
                                        <div class="form-group">
                                            <div v-if="isEditingStatus"
                                                 :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddress, '': trip.status_id==='' && isSubmit}">
                                                <select required
                                                        class="form-control border-0 py-0 shadow-none pr-5"
                                                        :disabled="!isEditingStatus"
                                                        :class="{view: !isEditingStatus}"
                                                        v-model="trip.status_id">
                                                    <option value="0">Awaiting goods</option>
                                                    <option value="1">New</option>
                                                    <option value="2">Transferred</option>
                                                    <option value="3">Scheduled</option>
                                                    <option value="4">Servicing</option>
                                                    <option value="5">Failed</option>
                                                    <option value="6">Rejected</option>
                                                    <option value="7">Delivered</option>
                                                    <option v-if="trip.status_id == 11" disabled value="11">Foreign</option>
                                                </select>
                                            </div>
                                            <div v-else>
                                                {{ trip.status_id !== 11 ? trip.status : "" }}
                                                {{ (trip.is_foreign && trip.status_id != 11) ? " / foreign" : "Foreign" }}
                                            </div>
                                        </div>

                                        <div
                                            v-if="(trip.status_id === 1 || trip.status_id === 2 || trip.status_id === 5) && trip.type!=='Linehaul' && trip.time_day!==null && trip.booking.status>1 ">
                                            <div class="btn btn-success" @click="sendToOptimoRoute()">
                                                Send to OptimoRoute
                                            </div>
                                        </div>
                                        <div v-else>
                                            <button disabled class="btn btn-success">Send to OptimoRoute</button>
                                        </div>
                                        <br/>

                                        <div v-if="trip.status_id!==1  && trip.type!=='Linehaul'">
                                            <div class="btn btn-danger" @click="deleteFromOptimoRoute()">
                                                Delete from OptimoRoute
                                            </div>
                                        </div>

                                        <div class="optimoroute-result" v-if="trip.optimoroute_result">
                                            <div v-if="trip.status_id===5"
                                                 class="optimoroute-error alert alert-danger" role="alert">
                                                <i> {{ trip.optimoroute_result }} </i>
                                            </div>
                                            <div v-else
                                                 class="optimoroute-error alert alert-success" role="alert">
                                                <i> {{ trip.optimoroute_result }} </i>
                                            </div>

                                        </div>

                                        <div class="custom-control custom-checkbox mb-3">
                                            <input type="checkbox" class="custom-control-input" id="tasks"
                                                   v-model="trip.is_task">
                                            <label class="custom-control-label" for="tasks">Tasks:</label>
                                        </div>

                                        <br/>
                                        <br/>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card mb-4 box-shadow h-100">
                            <div class="card-body">
                                <div class="trip-block-height p-4 mb-0 bg-white rounded-lg">
                                    <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                                        <div class="h3 mb-0">Trip summary</div>
                                    </div>
                                    <div class="pt-3">
                                        <div class="d-flex justify-content-between"><span>Driver:</span><span>{{
                                                trip.driver
                                            }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between"><span>Vehicle:</span><span>{{
                                                trip.vehicle
                                            }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <span>Time spent:</span><span>{{ trip.spent_minutes }} </span>
                                        </div>
                                        <div v-if="trip.pod" class="d-flex justify-content-between"><span>PoD:</span>
                                            <div>
                                                <a
                                                    class="btn btn-info btn-sm pod-button"
                                                    @click="downloadPod(trip.image, fileTypeImage)">
                                                    Download PoD
                                                </a>
                                            </div>
                                        </div>
                                        <div v-if="trip.signature" class="d-flex justify-content-between">
                                            <span>PoD:</span>
                                            <div><a
                                                class="btn btn-info btn-sm pod-button"
                                                @click="downloadPod(trip.signature, fileTypeSignature)">
                                                Download PoD</a>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <span>Comment:</span>
                                            <span>{{ trip.delivery_comment }}</span>
                                        </div>
                                        <div class="row" v-for="(service,key) in trip.services">
                                            <div class="col-sm-4"><p class="float-start"> {{
                                                    key === 0 ? 'Services:' :
                                                        ''
                                                }}</p>
                                            </div>
                                            <div class="col-sm-8"><p class="float-end">{{ service }}</p></div>
                                        </div>
                                        <div class="d-flex justify-content-between" v-if="role !== 'user'">
                                            <span>Internal comment:</span><span>{{
                                                trip.booking.internal_comment
                                            }} </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 mt-2">
                        <button type="submit" class="btn btn-primary btn-lg" @click="validation()">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </form>

        <br/>

        <a href="/trips" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>

        <!-- Dropoff date change confirmation modal -->
        <div class="modal fade" :class="{show, 'd-block': showDropoffConfirmModal}" style="z-index: 1060;">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Confirm Change</h5>
                        <button type="button" class="close" @click="cancelDropoffDateChange">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            Booking will have either a storage fee or deadline fee from the date last colli on booking have been received. Which fee should be added to booking?
                        </p>
                        <div class="custom-control custom-checkbox mb-2">
                            <input type="checkbox"
                                   class="custom-control-input"
                                   id="trip_storage_fee_confirmed"
                                   v-model="storageFeeConfirmed"
                                   @change="onFeeSelect('storage_fee')"
                            >
                            <label class="custom-control-label" for="trip_storage_fee_confirmed">
                                Storage fee (~ {{ calculatedFees.storage_fee_value ?? 0 }} kr) - <strong>Client</strong> pays
                            </label>
                        </div>
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox"
                                   class="custom-control-input"
                                   id="trip_deadline_fee_confirmed"
                                   v-model="deadlineFeeConfirmed"
                                   @change="onFeeSelect('deadline_fee')"
                            >
                            <label class="custom-control-label" for="trip_deadline_fee_confirmed">
                                Deadline fee (~ {{ calculatedFees.deadline_fee_value ?? 0 }} kr) - <strong>STEP</strong> pays
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cancelDropoffDateChange">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="confirmDropoffDateChange">Ok</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showDropoffConfirmModal" class="modal-backdrop fade show" style="z-index: 1050;"></div>
    </div>
</template>
<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import modalMixin from "../mixins/modalMixin";
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
export default {
    name: "TripEdit",
    mixins: [datePickerOptionsMixin, modalMixin],
    components: {DatePicker, VueTimepicker},
    props: {
        url: {type: String, required: true},
        role: {type: String, required: true},
        roleUser: {type: String, required: true},
        fileTypeImage: {type: String, required: true},
        fileTypeSignature: {type: String, required: true}
    },
    data() {
        return {
            countryList: {},
            isEditingAddress: false,
            isEditingStatus: false,
            optimoRouteSuccess: '',
            optimoRouteError: '',
            loadingOptimoRoute: false,
            trip: {'booking': '', 'client': {'primary_contact': ''}, 'address': {'country': 'Denmark'}},
            isSubmit: false,
            sendToOptimoRouteAfterSave: false,
            availableWeekDays: {
                1: {from: '00:00', to: '00:00', highlight: false},
                2: {from: '00:00', to: '00:00', highlight: false},
                3: {from: '00:00', to: '00:00', highlight: false},
                4: {from: '00:00', to: '00:00', highlight: false},
                5: {from: '00:00', to: '00:00', highlight: false},
            },
            show: false,
            previousTimeDay: null,
            showDropoffConfirmModal: false,
            calculatedFees: {
                storage_fee_value: 0,
                deadline_fee_value: 0
            },
            storageFeeConfirmed: true,
            deadlineFeeConfirmed: false,
        }
    },
    watch: {
        'trip.address.zip'(newVal) {
            this.getAvailableWeekDays(newVal).then(() => {
                if (this.trip.time_day) {
                    this.setHourRange(this.trip.time_day);
                }
            });
        },
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        updateTrip() {
            if (this.trip.status_id === 0 && this.trip.time_day !== '') {
                if (this.trip.optimoroute_result === null) {
                    this.sendToOptimoRouteAfterSave = true;
                }
            }
            axios.patch(`/trips/${this.trip.id}`, this.trip).then((response) => {
                if (this.sendToOptimoRouteAfterSave) {
                    this.sendToOptimoRouteConfirmed();
                }
                this.flashMessage.success({
                    title: '',
                    message: 'Trip succesfully updated',
                    time: 2000,
                    blockClass: 'flash-message'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }).catch((error) => {
                console.log(error.response.data);
                if (error.response.data.message) {
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                }

            });
        },
        sendToOptimoRouteConfirmed() {
            this.loadingOptimoRoute = true;
            axios.post(`/optimoroute/create-order/${this.trip.id}/0`, this.trip).then((response) => {
                if (this.trip.child_trip) {
                    axios.post(`/optimoroute/create-order/${this.trip.child_trip}/0`, this.trip).then((response) => {
                        window.location.reload();
                    }).catch();
                } else {
                    window.location.reload();
                }
            }).catch((error) => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 3000,
                    blockClass: 'flash-message error'
                });
                console.log(error.response);
            }).finally(() => {
                this.loadingOptimoRoute = false
            });
        },
        sendToOptimoRoute() {
            let showConfirm = false;
            if (this.trip.booking.driver_id !== null) {
                this.showConfirm = true;
            }
            if (this.showConfirm === true) {
                if (confirm("Are you sure you want to send an external booking to OptimoRoute?")) {
                    this.sendToOptimoRouteConfirmed()
                }
            } else {
                this.sendToOptimoRouteConfirmed()
            }
        },
        deleteFromOptimoRoute() {
            this.loadingOptimoRoute = true;
            axios.post(`/optimoroute/delete-order/${this.trip.id}/0`, this.trip).then((response) => {
            }).catch((error) => {
            }).finally(() => {
                this.loadingOptimoRoute = false
                window.location.reload();
            });
        },
        fetchData() {
            let dataFetchUrl = `${this.url}`
            axios.get(dataFetchUrl)
                .then(({data}) => {
                    this.trip = data.data;
                    this.previousTimeDay = this.trip.time_day;
                }).catch(error => this.trip = []);
            axios.get(`/country-list`)
                .then(({data}) => {
                    this.countryList = data.result;
                }).catch()
        },
        downloadPod(image, type) {
            axios({
                url: `/optimoroute/download-pod/${this.trip.id}/${type}`,
                method: 'POST',
                responseType: 'blob',
                data: image
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', image);
                document.body.appendChild(link);
                link.click();
            });
        },
        getAvailableWeekDays(zip) {
            return new Promise((resolve) => {
                this.availableWeekDays = {
                    1: {from: '00:00', to: '00:00', highlight: false},
                    2: {from: '00:00', to: '00:00', highlight: false},
                    3: {from: '00:00', to: '00:00', highlight: false},
                    4: {from: '00:00', to: '00:00', highlight: false},
                    5: {from: '00:00', to: '00:00', highlight: false},
                };
                if (!zip || zip.length < 4) {
                    resolve();
                    return;
                }

                setTimeout(() => {
                    axios.get(`/routes-get-week-days`, {
                            params: {
                                zip: zip,
                                totalVolume: this.trip.volume,
                                totalWeight: this.trip.weight,
                            }
                        })
                        .then((response) => {
                            if (response.data.availableDays && Object.keys(response.data.availableDays).length) {
                                this.availableWeekDays = response.data.availableDays;
                            }
                        }).catch((error) => {
                        console.log(error.response.data);
                    }).finally(() => {
                        resolve();
                    });
                }, 500);
            });
        },
        setHourRange(date) {
            if (this.role === this.roleUser) {
                return;
            }

            setTimeout(() => {
                let startTimePicker = this.$refs['StartTime'];
                let endTimePicker = this.$refs['EndTime'];
                let ul, elements;
                let day, from, to, timeRange;

                if (!startTimePicker && !endTimePicker) {
                    return;
                }

                if (date) {
                    let dateComponents = date.split('-');
                    date = `${dateComponents[2]}-${dateComponents[1]}-${dateComponents[0]}`;
                    date = new Date(date);
                    day = date.getDay().toString();
                }

                let hasAvailableTimeRange = false;
                if (day !== undefined &&
                    this.availableWeekDays[day] &&
                    this.availableWeekDays[day]['from'] &&
                    this.availableWeekDays[day]['to'] &&
                    (this.availableWeekDays[day]['from'] !== '00:00' || this.availableWeekDays[day]['from'] !== '00:00')
                ) {
                    from = this.availableWeekDays[day]['from'];
                    to = this.availableWeekDays[day]['to'];
                    hasAvailableTimeRange = true;
                }

                if (from && to) {
                    const range = [from.substring(0, 2), to.substring(0, 2)];
                    // Highlight hours selected on a route
                    const start = parseInt(range[0], 10);
                    const end = parseInt(range[1], 10);

                    timeRange = Array.from(
                        {length: end - start + 1},
                        (_, i) => String(start + i).padStart(2, "0")
                    );
                }

                for (let picker of [startTimePicker, endTimePicker]) {
                    ul = picker.querySelector('.hours');
                    elements = ul.querySelectorAll('li');
                    for (const element of elements) {
                        element.classList.remove('bg-success');
                        if (hasAvailableTimeRange && timeRange && timeRange.includes(element.dataset.key)) {
                            element.classList.add('bg-success');
                        }
                    }
                }
            }, 50);
        },
        getClassesDatepicker(date) {
            if (this.role === this.roleUser) {
                return '';
            }

            let day = date.getDay().toString();
            if (this.trip.address.zip &&
                (
                    Object.keys(this.availableWeekDays).length &&
                    Object.keys(this.availableWeekDays).includes(day) &&
                    this.availableWeekDays[day].highlight
                )
            ) {
                return 'text-white bg-success font-weight-bold';
            }

            return '';
        },
        handleDateChange(newDate) {
            this.setHourRange(newDate);

            if (this.trip.type === 'Drop-off' && newDate !== this.previousTimeDay) {
                let apiDate = null;
                if (newDate) {
                    const parts = newDate.split('-');
                    apiDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
                this.getFeesInfo(apiDate).then((data) => {
                    if (data.status === 'success') {
                        this.calculatedFees.storage_fee_value = data.data.storage_fee_value;
                        this.calculatedFees.deadline_fee_value = data.data.deadline_fee_value;
                        this.modalToggle('showDropoffConfirmModal');
                    }
                });
            }
        },
        async getFeesInfo(customDate) {
            try {
                const response = await axios.get(`/bookings/${this.trip.booking.id}/get-storage-deadline-data?customDropoffDate=${customDate}`);
                return response.data;
            } catch (e) {
                console.error(e);
                return e.response?.data || {status: 'error', message: 'An error occurred while calculating fees.'};
            }
        },
        confirmDropoffDateChange() {
            if (!this.storageFeeConfirmed && !this.deadlineFeeConfirmed) {
                return;
            }
            this.previousTimeDay = this.trip.time_day;
            this.trip.storage_fee_confirmed = this.storageFeeConfirmed;
            this.trip.deadline_fee_confirmed = this.deadlineFeeConfirmed;
            this.trip.storage_fee_value = this.calculatedFees.storage_fee_value;
            this.trip.deadline_fee_value = this.calculatedFees.deadline_fee_value;
            this.modalToggle('showDropoffConfirmModal');
        },
        cancelDropoffDateChange() {
            this.trip.time_day = this.previousTimeDay;
            this.storageFeeConfirmed = true;
            this.deadlineFeeConfirmed = false;
            this.modalToggle('showDropoffConfirmModal');
        },
        onFeeSelect(feeType) {
            if (feeType === 'storage_fee' && this.storageFeeConfirmed) {
                this.deadlineFeeConfirmed = 0;
            } else if (feeType === 'deadline_fee' && this.deadlineFeeConfirmed) {
                this.storageFeeConfirmed = 0;
            }
        },
    },
    created() {
        return this.fetchData()
    },
}
</script>
<style>
.optimoroute-result {
    margin-top: 10px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.float-end {
    margin-left: 100px;
}

.custom-control.custom-checkbox {
    padding-left: 0;
}

label.custom-control-label {
    position: relative;
    padding-right: 1.5rem;
}

label.custom-control-label::before, label.custom-control-label::after {
    right: 0;
    left: auto;
}

.pod-button {
    margin-bottom: 5px;
}
</style>
